<template>
    <div>
        <div class='toolsbar'>
            <span>
                <el-button type="primary" @click="addNewComplaintVisible = true" plain>新增投诉</el-button>
            </span>
        </div>

        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		> 
            <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
            <el-table-column prop="complainatName" label="用户"  align="center"></el-table-column>
            <el-table-column prop="createTime" label="投诉时间" align="center"></el-table-column>
            <el-table-column prop="disPoseStateName" label="处理状态"  align="center"></el-table-column>
            <el-table-column prop="complainatTypeName" label="问题类型"  align="center"></el-table-column>
            <el-table-column prop="disposeRemark" label="备注"  align="center"></el-table-column>
            <el-table-column label="操作" width="230" fixed="right" align="center">
                <template slot-scope="scope" >
                    <el-button type="text" size="small" @click="showOrderDetail(scope.row)">投诉详情</el-button>
                </template>                
            </el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        
        <el-dialog :append-to-body="true"  title="新增投诉" :visible.sync="addNewComplaintVisible" width="600px" :close-on-click-modal="false">
            <div class="lineInDialog">
                <label>投诉类型：</label>
                <span>
                    <el-radio v-model="complainatType" label="1">投诉上级</el-radio>
                    <el-radio v-model="complainatType" label="2">公司建议</el-radio>
                    <el-radio v-model="complainatType" label="3">其他投诉</el-radio>
                </span>
            </div>
            <div class="lineInDialog">
                <label>投诉详情：</label>
                <el-input  type="textarea" placeholder="请输入详细内容并在下方上传证据截图" :rows="5" v-model.trim="complainatRemark" clearable></el-input>
            </div>
            <div class="lineInDialog">
                <label >证据截图：</label>
                <div class="many">                    
                   <el-upload
                        action=""
                        list-type="picture-card"
                        :http-request="uploadFile"
                        ref="upload"
                        :auto-upload="false"
                        :on-remove="handleRemove">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :append-to-body="true"  :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addNewComplaintVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmDialogVisible = true">确 定</el-button>
            </span>            
        </el-dialog>
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmDialogVisible"
            width="30%">
            <span >确定要提交投诉吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleComplaint">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog :append-to-body="true" 
            title="投诉详情"
            :visible.sync="orderDetailVisible"
            width="30%">
            <label>投诉详情：</label>
            <el-input  type="textarea" placeholder="请输入详细内容并在下方上传证据截图" :rows="5" v-model.trim="echoComplainatRemark" clearable :disabled="true" style="color:#2f2f2f"></el-input>
            <div style="margin-top:10px;">证据截图：</div>
            <el-image v-for="url in complainatPhotos" 
            class="complainatPhotos"
            :key="url" :src="url" 
            :preview-src-list="complainatPhotos" lazy></el-image>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="orderDetailVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import {getAgentComplaintsList, deleteFeedback, replayFeedback, exportFeedback, doComplaint} from '@/api/system.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                packageName: '',
                iccid: '',
                orderNo: '',
                backOrderNo: '',
                time: ''
            },
            disabledFlag: false,
            complainatType:'1',
            complainatRemark:'',
            dialogImageUrl: '',
            dialogVisible: false,
            formDate:'',
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            orderDetailVisible : false,//投诉内容显示框
            disposeRemark:'',//回复内容
            echoComplainatRemark:'',//回显的投诉内容
            complainatPhotos:[],//回显截图路径
            addNewComplaintVisible:false,//新增
            confirmDialogVisible:false//确认对话框
        }
    },
    methods: {
        getListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getAgentComplaintsList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showOrderDetail(row){
            let photosArray = row.complainatPhotos.split("@@");
            for(let i=0; i<photosArray.length; i++){
                this.complainatPhotos[i] = process.env.VUE_APP_IMG_URL + '/' + photosArray[i];
            }
            this.echoComplainatRemark = row.complainatRemark;
            this.orderDetailVisible = true;
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getListPageHandle();
        },
        handleRemove(file, fileList) {
        },
        uploadFile(file){
            let reader = new FileReader();
            reader.readAsDataURL(file.file);
            this.formDate.append('files', file.file);

        },
        handleComplaint(){
            this.formDate = new FormData();
            this.$refs.upload.submit();
            this.formDate.append('complainatRemark', this.complainatRemark);
            this.formDate.append('complainatType', this.complainatType);

            doComplaint(this.formDate).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }
                this.confirmDialogVisible = false;
                this.addNewComplaintVisible = false;
                this.complainatRemark = '';
                this.complainatType = '';
                this.formDate.delete('files');
                this.formDate.delete('complainatRemark');
                this.formDate.delete('complainatType');
                this.getListPageHandle();
            });
        }        
    },
    created(){
        this.getListPageHandle();
    }
}
</script>
<style lang="less" scoped>
    .toolsbar{
        margin-bottom:10px;
    }
    .complainatPhotos{
        max-width: 200px; 
        max-height: 200px; 
        border:1px solid #cccbcb; 
        margin:5px 10px;
    }
</style>
